module.exports = require('@feathersjs/feathers');
